import script from "./HowToPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToPlay.vue?vue&type=script&setup=true&lang=js"

import "./HowToPlay.vue?vue&type=style&index=0&id=3f9763df&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9763df"]])

export default __exports__